import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { Heading } from '@warrenbrasil/nebraska-web';
import { AllocationChart } from '@/modules/catalog/components/AllocationChart';
import { AllocationChartLegend } from './components/AllocationChartLegend';

import { IAllocation } from '@/modules/catalog/services/variable-income';

interface Props {
  allocation: IAllocation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Allocation',
  props: {
    allocation: null
  },
  setup(__props: any) {

const props = __props as {
  allocation: IAllocation;
}



const title = computed(() => {
  return props.allocation?.title || '-';
});

return { __sfc: true,props, title, Heading, AllocationChart, AllocationChartLegend }
}

})